var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":-1,"virtual-rows":"","hide-default-footer":"","height":"500px"}})}
var staticRenderFns = []

export { render, staticRenderFns }